import { z } from 'zod'
import { isValidIBAN } from 'ibantools'

export const addBankAccountSchema = z.object({
  iban: z
    .string()
    .min(1, 'IBAN je povinný')
    // Normalizácia 1:1 s BE `normalizeIban` — 2FA kód je scopovaný na PRESNÝ IBAN
    // (generate data {iban} sa musí zhodovať s normalizovaným IBAN-om v add requeste)
    .transform((value) => value.replace(/[ -]/g, '').trim().toUpperCase())
    .refine((value) => isValidIBAN(value), {
      message: 'Neplatný formát IBAN',
    }),
  isOwner: z.boolean().refine((value) => value === true, {
    message: 'Potvrďte prosím, že účet je váš',
  }),
})

export type AddBankAccountSchema = z.infer<typeof addBankAccountSchema>
